import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'download-icon',
  /* eslint-disable */
  template: `
    <div class='download-icon'
      [class.inactive]='inactive'
      [class.failed]='failed'>
      <svg width="14px" height="15px" viewBox="0 0 14 15">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g class='icon' transform="translate(-1072.000000, -788.000000)">
            <g transform="translate(160.000000, 200.000000)">
              <g transform="translate(0.000000, 570.000000)">
                <g transform="translate(851.000000, 13.000000)">
                  <path d="M74.0666667,18 L61.9333333,18 C61.4181333,18 61,18.447 61,19 C61,19.553 61.4181333,20 61.9333333,20 L74.0666667,20 C74.5828,20 75,19.553 75,19 C75,18.447 74.5828,18 74.0666667,18 L74.0666667,18 Z M73,10.0711356 L69.41352,10.0711356 L69.41352,5 L66.5850658,5 L66.5850658,10.0711356 L63,10.0711356 L67.9992929,15.0704285 L73,10.0711356 Z" id="Icon"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  `,
  /* eslint-enable */
})
export class DownloadIconComponent {
  @Input() inactive: boolean = false;
  @Input() failed: boolean = false;
}
